// [red, green, blue, alpha], channels 0-255 and alpha 0-1, or undefined
// when the value is not a color (gradients, patterns, unknown names).
export type ColorParser = (value: string) => number[] | undefined;

const toHex = ([red, green, blue]: number[]) =>
  `#${[red, green, blue]
    .map((channel) => Math.round(channel).toString(16).padStart(2, '0'))
    .join('')}`;

// The distinct colors among `values`, most used first, as #rrggbb.
// Transparent colors are left out.
export const collectSlideColors = (
  values: unknown[],
  parse: ColorParser,
  limit = 12,
): string[] => {
  const counts = new Map<string, number>();
  values.forEach((value) => {
    if (typeof value !== 'string' || !value) return;
    const source = parse(value.trim().toLowerCase());
    if (!source || source[3] === 0) return;
    const hex = toHex(source);
    counts.set(hex, (counts.get(hex) || 0) + 1);
  });
  // Map keeps first-use order, and the sort is stable.
  return Array.from(counts.entries())
    .sort(([, a], [, b]) => b - a)
    .slice(0, limit)
    .map(([hex]) => hex);
};
